import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-goodsMgr",
  "use": "icon-goodsMgr-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-goodsMgr\"><defs><style type=\"text/css\"></style></defs><path d=\"M992 64 845.3 64 776 320 32 320c-9.6 0-18.7 4.3-24.7 11.7s-8.5 17.2-6.6 26.6l64 320c3 15 16.1 25.7 31.4 25.7l575.9 0-17.3 64-529 0c-17.7 0-32 14.3-32 32s14.3 32 32 32L160 832l512 0 31.5 0 190.8-704L992 128c17.7 0 32-14.3 32-32S1009.7 64 992 64zM122.2 640 71 384l687.6 0-69.4 256L122.2 640z\" p-id=\"2936\" /><path d=\"M64 928c0 53 43 96 96 96s96-43 96-96-43-96-96-96S64 875 64 928zM160 896c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32S142.4 896 160 896z\" p-id=\"2937\" /><path d=\"M576 928c0 53 43 96 96 96s96-43 96-96-43-96-96-96S576 875 576 928zM672 896c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32S654.4 896 672 896z\" p-id=\"2938\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/goodsMgr.svg
// module id = f2LE
// module chunks = 212